import classnames from 'classnames';
import React, { forwardRef } from 'react';

const BaseDropdown = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children, className, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement("div", {
        ...otherProps,
        className: classnames({
            'bf-dropdown': true,
            [`${className}`]: !!className
        }),
        ref: ref
    }, children);
});

export { BaseDropdown };
//# sourceMappingURL=base-dropdown.js.map
